<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$info"
    :title="$t('stat')"
    :loading="loading"
    :max-width="800"
    color="stat"
    activator-button
    @open="showDialog"
    @escape="closeDialog"
  >
    <template v-slot:info>
      <v-skeleton-loader
        v-if="!stat"
        type="table"
      />
      <v-container v-else>
        <v-data-table
          :headers="stat_headers"
          :items="stat"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="year"
          show-expand
          dense
          class="elevation-1"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="blue lighten-1 px-3">
              <v-row
                v-for="(row, i) in item.stat"
                :key="i"
                class="font-weight-medium white--text"
              >
                <v-col class="pl-16 ml-10">
                  {{ row.plane_type }}
                </v-col>
                <v-col class="px-4" style="max-width: 140px;">
                  {{ row.landing }}
                </v-col>
                <v-col class="px-4" style="max-width: 200px;">
                  {{ row.flight_time }}
                </v-col>
              </v-row>
            </td>
          </template>
        </v-data-table>
      </v-container>
    </template>
  </cumulus-info-dialog>
</template>

<script>

  import { call, get } from 'vuex-pathify'
  import CumulusInfoDialog from '@/components/InfoDialog'

  export default {
    name: 'LogbookGeneralStat',
    components: { CumulusInfoDialog },
    props: {
      date: {
        type: String,
        default: '',
      },
      userId: {
        type: Number,
        default: -1,
      },
    },
    data () {
      return {
        expanded: [],
        singleExpand: true,
        stat: null,
        dialogInfo: false,
        loading: false,
      }
    },
    computed: {
      stat_headers () {
        return [
          {
            text: this.$t('fields.year'),
            value: 'year',
          },
          {
            text: this.$t('fields.landing'),
            value: 'landing',
            width: 140,
          },
          {
            text: this.$t('flight_time'),
            value: 'flight_time',
            width: 200,
          },
        ]
      },
      profile: get('auth/profile'),
    },
    watch: {
      dialogInfo (val) {
        // this.showDialogFlightInfo()
        val || this.closeDialog()
      },
    },
    mounted () {
    },
    methods: {
      getStat: call('logbookGeneral/stat'),
      async showDialog () {
        console.log('showDayStat')
        this.loading = true
        await this.getStat({ date: this.date, user_id: this.userId }).then(response => {
          this.stat = response
          this.dialogInfo = true
          this.loading = false
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      },
      closeDialog () {
        this.stat = null
        this.dialogInfo = false
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
